import type { IconData } from '@stacksjs/iconify-core'

export const socialRewardsCertifiedRibbon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.91 1.52h1.52v28.95h-1.52Zm-3.05 28.95h3.05V32h-3.05Zm-1.52-1.52h1.52v1.52h-1.52Zm1.52-21.33h-1.52v1.52h-1.53v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.52h-1.52v-1.52h-1.53v-1.52h-1.52v1.52H9.15v1.52h1.52v1.53h1.52v1.52h1.53v1.53h1.52v-1.53h1.52v-1.52h1.53v-1.53h1.52v-1.52h1.53v-1.52h1.52v-1.53h1.52V9.14h-1.52zm-3.05 19.81h1.53v1.52h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.53h-1.53Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.52H9.15ZM6.1 0h19.81v1.52H6.1Zm0 30.47h3.05V32H6.1ZM4.57 1.52H6.1v28.95H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default socialRewardsCertifiedRibbon
